import { DataDefinition } from "../../rule-engine-core/Common/Data/DataDefinition";
import { DateDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/DateDataDefinition";
import { NumberDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { ObjectDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { StringDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { MappingConfiguration } from "../../rule-engine-core/Mapping/MappingConfiguration";

export const getMappingDataDefinition = () => {
    let definition = new MappingConfiguration();
    let idatadef = new DataDefinition();

    idatadef.fields.push(new NumberDataDefinition("expectedHours"));
    idatadef.fields.push(new NumberDataDefinition("spentHours"));
    idatadef.fields.push(new NumberDataDefinition("totalBudget"));

    let developer = new ObjectDataDefinition("developer1");
    developer.fields.push(new StringDataDefinition("firstName"));
    developer.fields.push(new StringDataDefinition("lastName"));
    developer.fields.push(new NumberDataDefinition("hourlyRate"));
    developer.fields.push(new NumberDataDefinition("totalWorkingHours"));
    idatadef.fields.push(developer);

    developer = new ObjectDataDefinition("developer2");
    developer.fields.push(new StringDataDefinition("firstName"));
    developer.fields.push(new StringDataDefinition("lastName"));
    developer.fields.push(new NumberDataDefinition("hourlyRate"));
    developer.fields.push(new NumberDataDefinition("totalWorkingHours"));
    idatadef.fields.push(developer);

    definition.inputData = idatadef;

    let odatadef = new DataDefinition();
    odatadef.fields.push(new NumberDataDefinition("spentMoney"));
    odatadef.fields.push(new NumberDataDefinition("remainedMoney"));
    odatadef.fields.push(new NumberDataDefinition("spentTotalHours"));
    odatadef.fields.push(new DateDataDefinition("expectedLaunchDate"));

    let owner = new ObjectDataDefinition("owner");
    owner.fields.push(new StringDataDefinition("name"));
    owner.fields.push(new NumberDataDefinition("age"));
    odatadef.fields.push(owner);

    definition.executionResult = odatadef;

    return definition;
};
